// Components
import { BaseTable, Loading, PermissionLink } from "components"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Utils
import { convertNumber } from "utils"
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils"

// Types
import type { TableSectionProps } from "pages/Purchase/Register/types"
import { PERMISION } from "security"
import { DeleteBill } from "../../DeleteBill"

export const TableSection = ({
  data,
  isLoading,
  refetch
}: TableSectionProps) => {
  const approvalChecked = (data: number) => {
    if (data === 1) {
      return "Pending"
    }
    if (data === 2) {
      return "Revisi"
    }
    if (data === 3) {
      return "Reject"
    }
    if (data === 4) {
      return "Approved"
    }
  }

  return (
    <div className="overflow-auto max-h-[calc(100vh-650px)]">
      <BaseTable className="border-transparent">
        <thead className="top-0 z-1 !bg-black !text-white">
          <tr className="uppercase">
            <th>No</th>
            <th>Bill Id#</th>
            <th>Ref Po Id#</th>
            <th>Delivery Date</th>
            <th>Vendor</th>
            <th>
              Status
              <br />
              Approval
            </th>
            <th>
              Qty
              <br />
              Delivered
            </th>
            <th>Location</th>
            <th>Total</th>
            <th>Payment</th>
            <th>
              Balance
              <br />
              Owing
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {!data.length || isLoading ? (
            <tr>
              <td colSpan={13} className="text-center">
                <Loading
                  loading={isLoading}
                  errorText={isLoading ? "" : "No data available"}
                />
              </td>
            </tr>
          ) : (
            data.map((val, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{val?.trx_code ?? "-"}</td>
                <td>{val?.trx_code_po ?? "-"}</td>
                <td>
                  {val?.transaction_date
                    ? convertDate(val?.transaction_date)
                    : "-"}
                </td>
                <td>{val?.vendor_name ?? "-"}</td>
                <td>
                  {val?.approve_status
                    ? approvalChecked(val?.approve_status)
                    : "-"}
                </td>
                <td className="text-center">
                  {val?.qty_delivered
                    ? convertNumber(val?.qty_delivered)?.intoNormalAmount
                    : "-"}
                </td>
                <td>{val?.location_name ?? "-"}</td>
                <td className="text-right">
                  {val?.sub_total
                    ? convertNumber(val?.sub_total)?.intoCurrency
                    : "0"}
                </td>
                <td className="text-right">
                  {val?.payment
                    ? convertNumber(val?.payment)?.intoCurrency
                    : "0"}
                </td>
                <td className="text-right">
                  {val?.balance_owing
                    ? convertNumber(val?.balance_owing)?.intoCurrency
                    : "0"}
                </td>
                <td>
                  <section className="flex items-center gap-2">
                    {!val.purchase_order_id || val.purchase_order_id === 0 ? (
                      <PermissionLink
                        permission={
                          PERMISION.PURCHASES.REGISTER.BILLS_ITEM.UPDATE
                        }
                        to={`/purchase/transaction/direct-bill/edit/${val.bill_id}`}
                        className="mt-1">
                        <IoSendSharp />
                      </PermissionLink>
                    ):(
                      <PermissionLink
                        permission={PERMISION.PURCHASES.REGISTER.BILLS_ITEM.UPDATE}
                        to={`/purchase/transaction/enter-bills/${val.purchase_order_id}/edit/${val.bill_id}`}
                        className="mt-1">
                        <IoSendSharp />
                      </PermissionLink>

                    )}
                   
                    {val?.approve_status === 1 && (
                      <DeleteBill
                        onSuccess={() => {
                          if (refetch) {
                            refetch()
                          }
                        }}
                        item={{
                          bill_id: val.bill_id?.toString(),
                          transaction_date: val.transaction_date,
                          trx_code: val.trx_code,
                          vendor_name: val.vendor_name
                        }}
                      />
                    )}
                  </section>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </BaseTable>
    </div>
  )
}
